import React, { useEffect, useState, useImperativeHandle, forwardRef } from "react"
import { SearchableSelect } from "../../../../../Common/Class/Select/SearchableSelec"
import { get } from "../../../../../../Model/Network/Config/Axios"

export const AllEntities = forwardRef(({ selected, onSelect }, ref) => {
 const [allEntities, setAllEntities] = useState([])
 const [internalSelected, setInternalSelected] = useState(selected)
 const [filterText, setFilterText] = useState("")

 useImperativeHandle(ref, () => ({
  setValue: (value) => {
   setInternalSelected(value)
   if (onSelect) {
    onSelect(value)
   }
  },
  getValue: () => {
   return internalSelected
  }
 }))

 useEffect(() => {
  get('heirarchy/entity/all', (e, r) => {
   if (r) {
    setAllEntities(r.entities)
   }
  })
 }, [])

 useEffect(() => {
  setInternalSelected(selected)
 }, [selected])

 // Filter entities based on filter text
 const filteredEntities = allEntities.filter(entity => {
  if (!filterText) return true
  
  const searchText = filterText.toLowerCase()
  return (
   (entity.name && entity.name.toLowerCase().includes(searchText)) ||
   (entity.registeredName && entity.registeredName.toLowerCase().includes(searchText))
  )
 })

 return (
  <SearchableSelect
   label='Select Entity'
   placeholder={'Select Entity'}
   items={filteredEntities.map(entity => ({ label: entity.name, id: entity.id,registeredName:entity.registeredName,name:entity.name }))}
   renderItems={(item)=>{
    return <div>
        <div className="label bold">{item.name}</div>
        <div>Registered Name: {item.registeredName}</div>
    </div>
   }}
   value={internalSelected}
   labelKey="name"
   onChange={text => {
    setFilterText(text)
   }}
   select={(val) => {
    setInternalSelected(val)
    setFilterText("")
    if (onSelect) {
     onSelect(val)
    }
   }}
  />
 )
})